<script lang="ts">
</script>

<div class="flex flex-col justify-between items-center login-background">
  <header class="container top-0 z-0">
    <div class="justify-between items-center" style="height:56px">
      <img style="height:36px" class="object-none w-full" src="/image/unext_communication_logo.svg" alt="logo" />
    </div>
  </header>

  <main class="container mt-10 mb-auto">
    <div class="flex justify-center text-2xl p-2">U-mobile(d)移管特別オファー申込ページ</div>

    <div class="flex justify-center text-xl font-semibold mt-20">お探しのページがみつかりません</div>

    <div class="flex justify-center mt-10">
      <div class="content-center justify-items-center p-2 w-full">
        <div class="text-center mb:font-sm w-full">
          <ul class="list-none">
            <li>入力したアドレスが間違っているか、ページが移動した可能性があります。</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="flex justify-center mt-10 mb-10">
      <button
        class="tracking-widest text-center text-sm underline h-auto w-auto"
        on:click={() => (window.location.href = 'https://www.umobile.jp/info/umb2025070102')}
      >
        サービス提供終了&代替サービス告知へ</button
      >
    </div>
    <div class="flex justify-center mx-10"></div>
  </main>
  <footer class="container" />
</div>

<style lang="postcss">
  .login-background {
    background-color: white;
  }
</style>
